// Constants
// Slices
import { UpdatableSlice } from "./UpdatableSlice";
/**
 * Enhanced slice implementation for diffable types T that extends IDiffable<T> and IEntity.
 * Extends the basic Slice with update and baseline functionality.
 * Uses EntityTable instead of BasicTable for diffing support.
 */ export class EntitySlice extends UpdatableSlice {
    /**
     * Merging a collection by index can strand a sub-entity's temporary id in the baseline, which then
     * re-serializes as a create and duplicates the sub-entity server-side.
     *
     * Gated so the index merge can be restored without a code change. The table is built once per
     * slice, so flipping the gate takes effect on the next app load.
     */ get atomicArrayKeys() {
        return this.configProvider().changeGates.DisableAtomicEntityArrayFolding ? undefined : this.declaredAtomicArrayKeys;
    }
    /**
     * @param name Name of the slice
     * @param indexDefinitions Index definitions for collections in the slice
     * @param configProvider Provider for app configuration
     * @param atomicArrayKeys Collections the update round-trip is authoritative for; see `atomicArrayKeys`
     */ constructor(name, indexDefinitions, configProvider, atomicArrayKeys){
        super(name, indexDefinitions, (a, b)=>a.version < b.version, configProvider, atomicArrayKeys);
    }
}
